import {
  GET_SINGLE_BILL_ERROR,
  GET_SINGLE_BILL_START,
  GET_SINGLE_BILL_SUCCESS,
} from 'constants/action-types/settings/getSingleBill';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_SINGLE_BILL_START:
      return {
        ...state,
        singleBill: {
          ...state?.singleBill,
          loading: true,
          error: null,
          data: [],
        },
      };
    case GET_SINGLE_BILL_ERROR:
      return {
        ...state,
        singleBill: {
          ...state?.singleBill,
          loading: false,
          error: payload?.message,
        },
      };
    case GET_SINGLE_BILL_SUCCESS:
      return {
        ...state,
        singleBill: {
          ...state?.singleBill,
          loading: false,
          data: payload?.data,
        },
      };
    default:
      return null;
  }
};
